<template>

    <v-container>
        <h2>About</h2>
       <div>
           See the Project on <a href="https://github.com/hemandee/k8s-practice" >GitHub</a>
        </div>

    </v-container>

</template>

<script>


    export default {
        name: 'About',

        methods: {

        },
        data: () => ({

        }),
    }
</script>

<style>
    html {
        overflow-y: hidden
    }
</style>